import { render, staticRenderFns } from "./tjjl.vue?vue&type=template&id=2b454238&scoped=true"
import script from "./tjjl.vue?vue&type=script&lang=js"
export * from "./tjjl.vue?vue&type=script&lang=js"
import style0 from "./tjjl.vue?vue&type=style&index=0&id=2b454238&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b454238",
  null
  
)

export default component.exports